import { Outlet, createFileRoute } from '@tanstack/react-router'

// Layout for the POS namespace. It renders only an <Outlet/> so the two POS
// surfaces under /sale render standalone (full-screen), not wrapped in shared
// chrome: the operator screen at /sale (sale.index.tsx) and the buyer-facing
// customer display at /sale/display (sale.display.tsx). Without this layout the
// /sale operator component owned the segment and, having no Outlet, rendered in
// place of /sale/display — customers saw the cashier UI instead of their display.
export const Route = createFileRoute('/_app/_authed/sale')({
    component: SaleLayout,
})

function SaleLayout() {
    return <Outlet />
}
